class TabNav {
    constructor() {
        let self = this;
        const components = document.querySelectorAll(".c-tabs");

        if (components.length === 0) return;

        components.forEach((component) => self.initTabs(component));
    }

    initTabs(component) {
        const navItems = component.querySelectorAll(".c-tabs__nav a");
        navItems.forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();

                // Remove all existing active classes
                let activeTabs = component.querySelectorAll(".is-active");
                activeTabs.forEach(function (tab) {
                    tab.classList.remove("is-active");
                });

                // mark nav-a as active
                event.target.classList.add("is-active");

                // mark tab content as active
                document
                    .getElementById(event.target.hash.substr(1))
                    .classList.add("is-active");
            });
        });
    }
}

export default new TabNav();
